import { render, staticRenderFns } from "./CaseDetailsDrawer.vue?vue&type=template&id=e3469d90"
import script from "./CaseDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./CaseDetailsDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports